var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.limitedProducts.length > 0)?_c('div',[_c('div',{staticClass:"text-caption error--text"},[_vm._v("Недоступные товары:")]),_vm._l((_vm.limitedProducts),function(product,index){return _c('div',{key:index,staticClass:"text-body-2",domProps:{"textContent":_vm._s(product.name)}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }